import React from "react";
import { IRCAIssueFilterSelected } from "pages/Corporate/RCA/RCAIssues/components/RCAIssuesFilters/RCAIssuesFiltersInterfaces";

export interface IRCAIssueFiltersContext {
    filters: IRCAIssueFilterSelected;
    handleFiltersChange: (value: IRCAIssueFilterSelected) => void;
    handleRemoveDefaultFilters: () => Promise<void>;
    handleSetFiltersDefault: (filters: IRCAIssueFilterSelected) => Promise<void>;
    userFiltersDefault: IRCAIssueFilterSelected | null;
    loadingDefaultOperations: boolean;
    isFiltersDefault: boolean;
}

export const initialRCAIssueFilters: IRCAIssueFilterSelected = {
    showCompleted: false,
    ownerIds: [],
    statusesIds: [],
    millsIds: [0],
    selectedAllMillsIds: [],
    meetingTypeIds: [],
    totalMeetingTypes: 0,
    searchText: "",
};

export const RCAIssueFiltersContext = React.createContext<IRCAIssueFiltersContext>({
    filters: initialRCAIssueFilters,
    handleFiltersChange: () => {},
    handleRemoveDefaultFilters: async () => {},
    handleSetFiltersDefault: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
    isFiltersDefault: false,
});
